import { BLACK_900, tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getInvestmentDetailsWidgetStyles = () => {
  var spacing = tokens.spacing;
  return StyleSheet.create({
    containerStyle: {
      paddingTop: spacing.SPACING_8,
      justifyContent: 'flex-start',
      paddingBottom: spacing.SPACING_16
    },
    priceBreakUpitemWrapper: {
      flex: 1
    },
    listContainer: {
      flexDirection: 'row'
    },
    accordianContainer: {
      paddingRight: spacing.SPACING_16
    },
    accordianContainerWrapper: {
      paddingTop: spacing.SPACING_8,
      paddingRight: spacing.SPACING_16
    },
    buttonWidgetContainer: {
      marginTop: tokens.spacing.SPACING_8,
      paddingHorizontal: spacing.SPACING_16
    },
    leftDetailsContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      flex: 1
    },
    leftDetailsItemContainer: {
      display: 'flex',
      flexDirection: 'row',
      marginRight: 4
    },
    rightDetailsItemContainer: {
      display: 'flex',
      flexDirection: 'row'
    },
    buttonContainer: {
      marginTop: spacing.SPACING_16
    },
    titleContentSpacer: {
      marginTop: spacing.SPACING_4
    },
    infoIconTooltip: {
      zIndex: 99,
      paddingLeft: spacing.SPACING_4
    },
    collapsibleContainer: {
      paddingRight: tokens.spacing.SPACING_0,
      paddingLeft: tokens.spacing.SPACING_16
    },
    nonCollapsibleContainer: {
      paddingTop: spacing.SPACING_16,
      paddingHorizontal: tokens.spacing.SPACING_16
    }
  });
};
export var getLeftRightListItemData = (props, isSmallScreen) => {
  var leftDetails = props.leftDetails,
    rightDetails = props.rightDetails;
  var leftItemColor = BLACK_900;
  var rightItemColor = BLACK_900;
  var leftItemFontType = "body-single-line-" + (isSmallScreen ? 'sm' : 'md');
  if (leftDetails === null || leftDetails === void 0 ? void 0 : leftDetails.isBold) leftItemFontType += '-bold';
  var rightItemFontType = "body-single-line-" + (isSmallScreen ? 'sm' : 'md');
  if (rightDetails === null || rightDetails === void 0 ? void 0 : rightDetails.isBold) rightItemFontType += '-bold';
  return {
    leftItemColor,
    leftItemFontType: leftItemFontType,
    rightItemColor,
    rightItemFontType: rightItemFontType
  };
};